import { Channels } from '@global/utils/nativescriptHost/nativescript-host';

export const goBack = (navigation: { canGoBack: () => boolean; goBack: () => void }, eventSender?: Channels) => () =>
    navigation.canGoBack() ? navigation.goBack() : eventSender?.navigate({ action: 'goBack' });
